export function GetErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message
  return String(error)
}

export function GetErrorName(error: unknown) {
  if (error instanceof Error) return error.name
  return String(error)
}
